import React, {useEffect, useState} from 'react';
import {DataGrid, GridToolbarContainer, GridToolbarExport, GridOverlay} from '@mui/x-data-grid';
import {getAllCommentData} from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";
import CommentListPopupBox from "../../../atoms/CommentListPopupBox";
import CircularProgress from '@mui/material/CircularProgress';
import {Box} from '@mui/material';
import '../../ExcelUploads/AssetInfo/AssetList.css';

/* ─── Date Helper (unchanged) ─── */
function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport/>
        </GridToolbarContainer>
    );
}

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);

function CommentList() {
    /* ─── All State (unchanged) ─── */
    const [items, setItems] = useState([]);
    const [tag, setTag] = useState('');
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    /* ─── Modal Handlers (unchanged) ─── */
    const handleConfirmOpen = async (tag) => {
        setTag(tag);
        setIsConfirmOpen(true);
    };

    const handleConfirmClose = () => {
        setIsConfirmOpen(false);
    };

    /* ─── Columns (backend unchanged – only styling updated) ─── */
    const columns = [
        {
            field: "tag", editable: false, hide: false, headerName: "TAG", width: 350,
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.row.tag, 'back_url': 'view-comments'
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/asset-basic-details?tag=${EncryptID}`}><i className="bi bi-tag-fill"></i> {params.value}</a>;
            }
        },
        {
            field: "created_date", editable: true, hide: false, headerName: "Date of Addition", width: 180,
            renderCell: (params) => <p>{getFormatedDate(params.row.created_date)}</p>
        },
        {
            field: "view_comment", editable: false, hide: false, headerName: "View Comment List", width: 200,
            renderCell: (params) => (
                <button
                    className="al-btn al-btn-primary al-btn-sm"
                    onClick={() => handleConfirmOpen(params.row.tag)}
                    style={{margin: '4px 0'}}
                >
                    <i className="bi bi-eye-fill"/> View Comments
                </button>
            )
        },
    ];

    /* ─── Data Fetching (unchanged logic) ─── */
    useEffect(() => {
        setLoading(true);
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}

        getAllCommentData(oData).then(res => {
            if (res?.data?.data?.length) setItems(res.data.data);
            setLoading(false);
        }).catch(error => {
            console.error('Error fetching comments:', error);
            setLoading(false);
        });
    }, []);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="comment-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-chat-square-dots-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Additional Comments List</h5>
                        <p className="al-page-subtitle">View and manage asset comments</p>
                    </div>
                </div>
                {!loading && items.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-chat-left-text-fill"/>
                        <strong>{items.length.toLocaleString('en-IN')}</strong>&nbsp;Comment Records
                    </div>
                )}
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Comment Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> records
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={50}
                        autoHeight
                        rowsPerPageOptions={[50]}
                        className="al-data-grid"
                        components={{
                                Toolbar: CustomToolbar,
                                LoadingOverlay: CustomLoader,
                            }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {color: '#000',fontSize: '0.88rem'},
                            '& .MuiDataGrid-sortIcon': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-menuIconButton': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {color: 'rgba(255,255,255,0.85)'},
                            '& .MuiDataGrid-row': {fontSize: '0.8rem'},
                            '& .MuiDataGrid-row:hover': {backgroundColor: '#eef7fd'},
                            '& .MuiDataGrid-row.Mui-selected': {backgroundColor: '#d8f0fa'},
                            '& .MuiDataGrid-cell': {borderColor: '#f0f2f5'},
                            '& .MuiDataGrid-footerContainer': {borderTop: '1px solid #e2e6ef', background: '#f8f9fc'},
                            '& .MuiDataGrid-virtualScroller': {backgroundColor: '#fff'},
                            '& .MuiDataGrid-toolbarContainer': {
                                padding: '12px 16px',
                                borderBottom: '1px solid #e2e6ef',
                                '& .MuiButton-root': {
                                    color: '#0e8aca',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    '&:hover': {
                                        backgroundColor: 'rgba(14, 138, 202, 0.08)',
                                    }
                                }
                            }
                        }}
                    />
                </Box>
            </div>

            {/* ══ COMMENT POPUP MODAL (unchanged) ══ */}
            <CommentListPopupBox
                tag={tag}
                isOpen={isConfirmOpen}
                onClose={handleConfirmClose}
            />
        </div>
    )
}

export default CommentList